import { Roles } from "enum/roles.enum";
import { IUser } from "models/user/user.model";

export const isUserAdmin = (user: IUser): boolean => {
  return (
    (user && user["https://connexx.com/roles"]?.includes(Roles.ITD_STAFF)) ||
    false
  );
};
